import Dashboard from './Dashboard';
import Login from './Login';
import NewAccount from './NewAccount';
import Paywall from './Paywall';
import SubscriptionLimit from './SubscriptionLimit';
import CostRadarTrial from './CostRadarTrial';
import StoryousIntegration from './StoryousIntegration';
import EinvoicingIntegration from './EinvoicingIntegration';
import VenueManagement from './VenueManagement';
import CustomCheckout from './CustomCheckout';
import InvoiceBilling from './InvoiceBilling';
import SupplierIntegrations from './SupplierIntegrations';
import GracePeriod from './GracePeriod';
import { RouteType } from './types';

export const privateRoutes: Array<RouteType> = [
  Dashboard,
  NewAccount,
  Paywall,
  SubscriptionLimit,
  CostRadarTrial,
  StoryousIntegration,
  EinvoicingIntegration,
  VenueManagement,
  CustomCheckout,
  InvoiceBilling,
  SupplierIntegrations,
  GracePeriod,
];

export {
  Dashboard as DashboardRoute,
  Login as LoginRoute,
  NewAccount as NewAccountRoute,
  Paywall as PaywallRoute,
  SubscriptionLimit as SubscriptionLimitRoute,
  CostRadarTrial as CostRadarTrialRoute,
  StoryousIntegration as StoryousIntegrationRoute,
  EinvoicingIntegration as EinvoicingIntegrationRoute,
  VenueManagement as VenueManagementRoute,
  CustomCheckout as CustomCheckoutRoute,
  InvoiceBilling as InvoiceBillingRoute,
  SupplierIntegrations as SupplierIntegrationsRoute,
  GracePeriod as GracePeriodRoute,
};

export const publicRoutes: Array<Omit<RouteType, 'icon'>> = [Login];
